import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createSlots as _createSlots } from "vue"

const _hoisted_1 = { style: {"display":"flex","justify-content":"flex-end"} }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("导出")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("导出所有分公司得分定级")
const _hoisted_4 = { class: "dialog-footer" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 确认 ")
const _hoisted_7 = ["innerHTML"]

import stubs from '@/init';
import { computed, reactive } from 'vue';
import RptSubsidiaryController from './controller/RptSubsidiary.Controller';
import {
  RptSubsidiaryDownloadColumnEnum,
  RptSubsidiaryParamVO,
  RptSubsidiaryVO,
} from './vo';
import { CockpitYearSubsidiaryVO, CockpitYearVO } from '../home/vo';
import { ElMessage } from 'element-plus';
import Wapper from '@/components/common/high/wapper.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const controller: RptSubsidiaryController = stubs.injector.get(
  RptSubsidiaryController
);
const state = reactive({
  form: {} as RptSubsidiaryParamVO,
  data: [] as Array<RptSubsidiaryVO>,
  years: [] as Array<CockpitYearVO>,
  dialogFormVisible: false,
  fields: [] as RptSubsidiaryDownloadColumnEnum[],
  selectedRegionId: '',
});

const tableColumns: any[] = [
  { label: '分公司得分', prop: 'riskValue' },
  {
    label: '分公司定级',
    prop: 'riskLevel',
  },
  { label: '风险模块', prop: 'moduleName' },
  {
    label: '模块权重',
    prop: 'moduleWeight',
    formatter: (row: any) => multiple100(row.moduleWeight),
  },
  { label: '模块得分', prop: 'moduleValue' },
  {
    label: '模块定级',
    prop: 'moduleLevel',
  },
  { label: 'KRI名称', prop: 'moduleKriName' },
  {
    label: 'KRI权重',
    prop: 'moduleKriWeight',
    formatter: (row: any) => multiple100(row.moduleKriWeight),
  },
  { label: 'KRI得分', prop: 'moduleKriValue' },
  { label: 'KRI指标名称', prop: 'kriMetricsName', minWidth: '180px' },
  {
    label: 'KRI指标权重',
    prop: 'kriMetricsWeight',
    formatter: (row: any) => multiple100(row.kriMetricsWeight),
  },
  { label: 'KRI指标值', prop: 'displayKriMetricsValue' },
  {
    label: 'KRI指标定级',
    prop: 'kriMetricsLevel',
  },
];

const regions = computed(() => {
  return (
    state.years.find((item) => item.year === state.form.year)?.region || []
  ).map((it: any) => ({ label: it.name, value: it.id }));
});

const subsidiary = computed(() =>
  (state.years.find((item) => item.year === state.form.year)?.subsidiary || [])
    .filter((sub: any) => {
      return (
        !state.selectedRegionId || state.selectedRegionId.includes(sub.regionId)
      );
    })
    .map((it: CockpitYearSubsidiaryVO) => ({ label: it.name, value: it.id }))
);

const multiple100 = (num: number | null | undefined) => {
  if (typeof num === 'number') return num * 100 + '%';
  return num;
};

const calcColSpanMethod = (
  data: Array<any>,
  key: string,
  fromIndex: number,
  toIndex: number
) => {
  if (fromIndex <= toIndex) {
    throw new Error('fromIndex不能小于等于toIndex');
  }
  const indicies = [fromIndex, toIndex];
  const sliceData = data.slice(toIndex, fromIndex);
  sliceData.forEach((it) => (it[key + '-span'] = 1));
  if (fromIndex === toIndex + 1) {
    return [fromIndex, toIndex];
  }
  sliceData.reverse();
  sliceData
    .filter((it) => it)
    .reduce((prev, cur, index) => {
      if (prev[key] === cur[key]) {
        cur[key + '-span'] += prev[key + '-span'];
        prev[key + '-span'] = 0;
      } else {
        indicies.push(fromIndex - index);
      }
      return cur;
    });
  return indicies;
};

const colors = ['#00fa99', '#37fdff', '#fac800', '#ff6c00', '#f03200', '#fff'];
colors.reverse();
const CellStyle = ({ row, columnIndex }: { row: any; columnIndex: number }) => {
  if (tableColumns[columnIndex].label.includes('定级')) {
    let index = 0;
    try {
      index = row[tableColumns[columnIndex].prop] || 0;
    } catch (e) {
      console.log(e);
    }
    return {
      backgroundColor: colors[index],
    };
  }
  return {};
};

const search = async () => {
  if (!state.form.year || !state.form.companyId) {
    ElMessage.warning({
      message: '请选择年份/公司',
    });
    return;
  }
  state.data = await controller.rpt(state.form);
  let iter = [state.data.length, 0];
  for (const prop of tableColumns.map((it) => it.prop)) {
    let newIter: number[] = [];
    iter.reduce((fromIndex, toIndex) => {
      newIter = [
        ...newIter,
        ...calcColSpanMethod(state.data, prop, fromIndex, toIndex),
      ];
      return toIndex;
    });
    newIter.sort((a, b) => b - a);
    iter = Array.from(new Set(newIter));
  }
};

const handleSpanMethod = ({ row, column, rowIndex, columnIndex }: any) => {
  const prop = tableColumns[columnIndex].prop;
  return [row[prop + '-span'], 1];
};

const download = () => {
  if (!state.form.year || !state.form.companyId) {
    ElMessage.warning({
      message: '请选择年份/公司',
    });
    return;
  }
  state.fields = [];
  state.dialogFormVisible = true;
};

const downloadExec = () => {
  if (!state.form.year || !state.form.companyId) {
    ElMessage.warning({
      message: '请选择年份/公司',
    });
    return;
  }
  controller.download({
    ...state.form,
  });
  state.dialogFormVisible = false;
};
const allSubsidiarySimpleDownload = () => {
  if (!state.form.year ) {
    ElMessage.warning({
      message: '请选择年份',
    });
    return;
  }
  controller.allSubsidiarySimpleDownload({
    ...state.form,
  });
};


const reset = () => {
  state.selectedRegionId = '';
  state.form = { year: '', companyId: '' };
};

const init = async () => {
  state.years = await controller.year();
};

init();

return (_ctx: any,_cache: any) => {
  const _component_simple_select = _resolveComponent("simple-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_mas_form_main = _resolveComponent("mas-form-main")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_simple_table_column = _resolveComponent("simple-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Wapper, null, {
      default: _withCtx(() => [
        _createVNode(_component_mas_form_main, {
          inline: true,
          form: _unref(state).form,
          defaultFormFooterButton: ['confirm', 'reset'],
          defaultFormFooterConfirmText: "搜索",
          "label-width": "120px",
          onConfim: _cache[3] || (_cache[3] = ($event: any) => (search())),
          onReset: reset
        }, {
          content: _withCtx((slotProps) => [
            _createVNode(_component_el_form_item, { label: "年份" }, {
              default: _withCtx(() => [
                _createVNode(_component_simple_select, {
                  style: {"width":"240px"},
                  options: 
                _unref(state).years.map((it) => ({ label: it.year, value: it.year }))
              ,
                  modelValue: slotProps.content.year,
                  "onUpdate:modelValue": ($event: any) => ((slotProps.content.year) = $event),
                  onChange: _cache[0] || (_cache[0] = 
                () => {
                  _unref(state).form.companyId = '';
                  _unref(state).selectedRegionId = '';
                }
              )
                }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_el_form_item, { label: "大区" }, {
              default: _withCtx(() => [
                _createVNode(_component_simple_select, {
                  style: {"width":"240px"},
                  options: _unref(regions),
                  modelValue: _unref(state).selectedRegionId,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).selectedRegionId) = $event)),
                  onChange: _cache[2] || (_cache[2] = ($event: any) => (_unref(state).form.companyId = ''))
                }, null, 8, ["options", "modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "分公司" }, {
              default: _withCtx(() => [
                _createVNode(_component_simple_select, {
                  style: {"width":"240px"},
                  options: _unref(subsidiary),
                  modelValue: slotProps.content.companyId,
                  "onUpdate:modelValue": ($event: any) => ((slotProps.content.companyId) = $event)
                }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }, 8, ["form"])
      ]),
      _: 1
    }),
    _createVNode(Wapper, null, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: downloadExec
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: allSubsidiarySimpleDownload
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_el_dialog, {
              modelValue: _unref(state).dialogFormVisible,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(state).dialogFormVisible) = $event)),
              title: "导出",
              width: "600"
            }, {
              footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_el_button, {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(state).dialogFormVisible = false))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: downloadExec
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  })
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_form, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "导出列" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_simple_select, {
                          modelValue: _unref(state).fields,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(state).fields) = $event)),
                          options: _ctx.pocket('rptSubsidiaryDownloadColumn'),
                          multiple: ""
                        }, null, 8, ["modelValue", "options"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createVNode(_component_el_table, {
            class: "common-table",
            data: _unref(state).data,
            "span-method": handleSpanMethod,
            "cell-style": CellStyle,
            border: ""
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tableColumns, (tableColumn) => {
                return _createVNode(_component_simple_table_column, _normalizeProps(_guardReactiveProps(tableColumn)), _createSlots({ _: 2 }, [
                  (tableColumn.formatter)
                    ? {
                        name: "default",
                        fn: _withCtx(({ row }) => [
                          _createElementVNode("div", {
                            innerHTML: tableColumn.formatter(row)
                          }, null, 8, _hoisted_7)
                        ])
                      }
                    : undefined
                ]), 1040)
              }), 64))
            ]),
            _: 1
          }, 8, ["data"])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})